<template>
    <footer class="conteiner d-flex flex-column justify-content-center align-items-around " style="background-color: #F5F5F5;">
        <div class="row d-flex align-items-around my-md-3 my-2 m-0">
            <div class="col-lg-3 col-sm-6 col-12">
                <div class="d-flex justify-content-center">
                    <img class="zoom-hover img-fluid" :src="logo" alt="logo wiks" width="261" height="199" loading="lazy"
                    style="width: 150px; height: 150px; object-fit: scaledown; cursor: pointer;">
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-12">
                <p class="text-lg-start text-center description-xs epilogue-semibold">Contáctenos</p>
                <ul class="list-unstyled text-sm-start text-center mx-lg-3 mx-5">
                    <li  class="zoom-hover"> 
                        <a class="description-xxs text-decoration-none text-uppercase epilogue-regular" href="mailto:contacto@mexicanosalgritodeayuda.org " target="_blank" style="cursor: pointer;">Correo electrónico</a>
                        <br>
                        <a class="description-xxs text-decoration-none text-uppercase epilogue-regular" href="tel:+525512345678" target="_blank" style="cursor: pointer;">Teléfono</a>
                        <br>
                        <a class="description-xxs text-decoration-none text-uppercase epilogue-regular" style="cursor: pointer;">01080 Ciudad de México, México</a>
                    </li>
                </ul>
            </div>
            <div class="col-lg-3 col-sm-6 col-12">
                <p class="text-lg-start text-center description-xs epilogue-semibold">Enlaces rápidos</p>
                <ul class="list-unstyled text-sm-start text-center mx-lg-3 mx-5">
                    <li class="zoom-hover" > 
                        <a class="description-xxs text-decoration-none text-uppercase epilogue-regular" @click="router.push('/nosotros');" style="cursor: pointer;">Nosotros</a>
                        <br>
                        <a class="description-xxs text-decoration-none text-uppercase epilogue-regular" @click="router.push('/talleres');" style="cursor: pointer;">Talleres/Expo</a>
                        <br>
                        <a class="description-xxs text-decoration-none text-uppercase epilogue-regular" @click="router.push('/eventos');" style="cursor: pointer;">Eventos</a>
                        <br>
                        <a class="description-xxs text-decoration-none text-uppercase epilogue-regular" @click="router.push('/blog');" style="cursor: pointer;">Blog</a>
                    </li>
                </ul>
            </div>
            <div class="col-lg-3 col-sm-6 col-12">
                <p class="text-lg-start text-center description-xs epilogue-semibold">Síganos</p>
                <div class="d-flex flex-row justify-content-center ">
                    <a href="https://www.facebook.com/MEXICANOSALGRITODEAYUDA/?locale=es_LA"
                        target="_blank" style="opacity: 1;">
                        <img :src="fb" class="zoom-hover" alt="logo facebook" width="45" height="45" loading="lazy">
                    </a>
                    <a class="mx-2"
                        target="_blank" href="https://www.instagram.com/mexicanosalgritodeayudaac/?hl=af" style="opacity: 1;">
                        <img :src="ins" class="zoom-hover" alt="logo instagram" width="45" height="45" loading="lazy">
                    </a>
                    <a class="me-2" href="#" style="opacity: 1;">
                        <img :src="tk" class="zoom-hover" alt="logo twitter" width="45" height="45" loading="lazy">
                    </a>
                    <a href="https://api.whatsapp.com/send?phone=5215512345678&text=Me%20gustaría%20más%20información" style="opacity: 1;">
                        <img :src="wp" class="zoom-hover" alt="logo whatsapp" width="45" height="45" loading="lazy" target="_blank">
                    </a>
                </div>
            </div>
        </div>
        <div class="col-12 d-flex  flex-wrap justify-content-around align-items-center mb-2 bg-white p-0">
            <img  v-for="(image, index) in images" :key="`bank_${index}`"
                class="img_hover"
                style="object-fit: scale-down;"
                :height="image.size"
                :src="image.image" 
                loading="lazy"
                :alt="image.alt">
        </div>



        <div class="col-12 text-center bg-primary">
            <a style="letter-spacing: 1px; font-size: 15px;" target="_blank" href="https://monocilindrero.com/" class="text-decoration-none text-white description-xs mb-1">
                Desarrollado por                                
                <a href="https://monocilindrero.com/" Target="_blank" class="text-decoration-none">
                    <b class="dmsans-semibold" style="color: #FF0000">monocilindrero.com </b>                                    
                    <a href="https://monocilindrero.com/" Target="_blank">
                        <img :src="mono" style="max-height: 25px;" class="m-1">
                    </a>
                </a>
            </a>
        </div>
    </footer>
</template>
<script setup>
    import { ref, computed, reactive, resolveComponent } from 'vue';
    import { useRouter } from 'vue-router'
    import { useStore } from 'vuex';
    

    //hooks
    const router = useRouter();

    const logo = require('ASSETS/icons/logo')

    const fb = require('ASSETS/icons/facebook')
    const ins = require('ASSETS/icons/instagram')
    const tk = require('ASSETS/icons/tiktok')
    const wp = require('ASSETS/icons/whatsapp')

    const mono = require('ASSETS/images/monologo')

    const options = [
        {
            label: 'Correo electrónico:'
        },
        {
            label: 'Teléfono: +52 55 1234 5678'
        },
        {
            label: 'Dirección: CDMX, México.'
        },
    ]
    const options2 = [
        {
            label: 'Inicio',
            route: 'home'
        },
        {
            label: 'Nosotros',
            route: 'nosotros'
        },
        {
            label: 'Talleres',
            route: 'talleres'
        },
        {
            label: 'Eventos',
            route: 'eventos'
        },
        {
            label: 'Blog',
            route: 'blog'
        },

    ]

</script>
<style lang="">
    
</style>